export default "__VITE_PUBLIC_ASSET__8e6c3fea__"